import type { FullCalendarEvent } from '../types'
import type { ScheduleEventHelper } from './scheduleEventHelper'

/**
 * Convert ScheduleEventHelpers to FullCalendar events
 */
export const toFullCalendarEvents = (
  helpers: ScheduleEventHelper[],
): FullCalendarEvent[] => {
  return helpers.map((helper) => helper.getFullCalendarEvent())
}
